module.exports = __webpack_public_path__ + "img/2012-08-18 17.08.51.1a9f1801.jpg";